module.exports = __webpack_public_path__ + "img/10_60.714a9658.png";